import { Home, Search, Map, Gift, User } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomNav.css';

const BottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path: string) => location.pathname === path;

    const navItems = [
        { icon: Home, label: 'Início', path: '/' },
        { icon: Search, label: 'Explorar', path: '/categories' },
        { icon: Map, label: 'Mapa', path: '/map' },
        { icon: Gift, label: 'Benefícios', path: '/benefits' },
        { icon: User, label: 'Perfil', path: '/profile' },
    ];

    return (
        <nav className="bottom-nav">
            {navItems.map((item) => (
                <button
                    key={item.path}
                    className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
                    onClick={() => navigate(item.path)}
                >
                    <item.icon size={24} strokeWidth={isActive(item.path) ? 2.5 : 2} />
                    <span className="nav-label">{item.label}</span>
                </button>
            ))}
        </nav>
    );
};

export default BottomNav;
